<template>
    <select id="state" name="state" class="form-control state-control">
        <option value="">Please select state</option>
        <option :v-if="this.States.StateID" v-for="(state, index) in sortedStates"
        :key="index" :value="state.StateCode">{{state.StateName}}</option>
    </select>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { statesAPI } from '../../constants/api.config'
    export default {
        name: "StatesDropdown",
        props: ["CountryCode"],
        data() {
            return {
                States: [
                    {
                        StateID: "",
                        StateName: "",
                        CountryCode: "",
                        StateCode: ""
                    }
                ],
            }
        },
        methods: {
            getAllStates(data) {
                let s = [];
                data.forEach(element => {
                    s.push(
                        {
                            StateID: element.stateID,
                            StateName: element.stateName,
                            CountryCode: element.countryCode,
                            StateCode: element.stateCode
                        }
                    );
                });

                return s;
            },
        },
        computed: {
            sortedStates() {
                let sortedStates = this.States.filter(s => s.CountryCode === this.CountryCode);                
                sortedStates = sortedStates.sort((a,b) => {
                    let fa = a.StateName.toLowerCase(), fb = b.StateName.toLowerCase();
                    if (fa < fb) {
                        return -1
                    }
                    if (fa > fb) {
                        return 1
                    }
                    return 0
                });

                return sortedStates;
            }
        },
        mounted() {
            var storage = localStorage.getItem('stateslist');
            if (storage) {
                this.States = JSON.parse(storage);
            }
            else {
                axios.get(getEndPoint(statesAPI))
                    .then((response) => (
                        this.States = this.getAllStates(response.data),
                        localStorage.setItem('stateslist', JSON.stringify(this.States))
                    ))
                    .catch((error) => console.log(error));
            }
        }
    };
</script>
